const STYLE_ID = 'deliving-colour-swatches-upgrade-styles';

function injectStyles() {
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    .deliving-card-colours {
      margin: 9px 0 7px;
      position: relative;
      z-index: 4;
    }

    .deliving-card-colours__row {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 7px;
      position: relative;
      z-index: 5;
    }

    .deliving-card-colour-swatch,
    .deliving-card-colour-more {
      box-sizing: border-box;
      width: 42px;
      min-width: 42px;
      height: 42px;
      min-height: 42px;
      border-radius: 0;
      background: #fff;
    }

    .deliving-card-colour-swatch {
      border-radius: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #dedede;
      overflow: hidden;
      text-decoration: none;
      transition: border-color .18s ease, transform .18s ease, box-shadow .18s ease;
      position: relative;
      z-index: 6;
    }

    .deliving-card-colour-extra[hidden],
    .deliving-pdp-colour-extra[hidden] {
      display: none !important;
    }

    .deliving-card-colour-swatch:hover {
      border-color: #555;
      transform: translateY(-1px);
    }

    .deliving-card-colour-swatch.is-active {
      border: 1px solid #111;
      box-shadow: none;
    }

    .deliving-card-colour-swatch img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: #fff;
    }

    .deliving-card-colour-more {
      appearance: none;
      -webkit-appearance: none;
      border: 1px solid #dedede;
      display: inline-grid;
      place-items: center;
      padding: 0;
      margin: 0;
      color: #111;
      font: inherit;
      font-size: 15px;
      font-weight: 650;
      line-height: 1;
      cursor: pointer;
      position: relative;
      z-index: 7;
      transition: border-color .18s ease, background-color .18s ease, transform .18s ease;
    }

    .deliving-card-colour-more:hover {
      border-color: #111;
      background: #fafafa;
      transform: translateY(-1px);
    }

    .deliving-card-colour-more__expanded {
      display: none;
      font-size: 21px;
      font-weight: 450;
    }

    .deliving-card-colours[data-expanded='true'] .deliving-card-colour-more__collapsed {
      display: none;
    }

    .deliving-card-colours[data-expanded='true'] .deliving-card-colour-more__expanded {
      display: inline;
    }

    .deliving-card-colours__summary {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-top: 7px;
      color: #666;
      font-size: 12px;
      line-height: 1.25;
      position: relative;
      z-index: 5;
    }

    .deliving-card-colours__summary-dot {
      width: 7px;
      height: 7px;
      border-radius: 999px;
      background: #d7c9b5;
      flex: 0 0 7px;
    }

    /* DeLiving PDP swatches: square corners */
    ul[class*="ai-color-swatches-list-"] *,
    ul[class*="ai-color-swatches-list-"] *::before,
    ul[class*="ai-color-swatches-list-"] *::after {
      border-radius: 0 !important;
    }

    .deliving-pdp-colour-more-item {
      list-style: none;
      display: block;
    }

    .deliving-pdp-colour-more-button {
      appearance: none;
      -webkit-appearance: none;
      width: var(--deliving-pdp-colour-width, 48px);
      min-width: var(--deliving-pdp-colour-width, 48px);
      height: var(--deliving-pdp-colour-height, 48px);
      min-height: var(--deliving-pdp-colour-height, 48px);
      box-sizing: border-box;
      border: 1px solid #d8d8d8;
      border-radius: 0;
      background: #fff;
      color: #111;
      padding: 3px;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      line-height: 1;
      transition: border-color .18s ease, background-color .18s ease, transform .18s ease;
    }

    .deliving-pdp-colour-more-button:hover {
      border-color: #111;
      background: #fafafa;
      transform: translateY(-1px);
    }

    .deliving-pdp-colour-more-count {
      font-size: 14px;
      font-weight: 700;
      line-height: 1;
    }

    .deliving-pdp-colour-more-label {
      margin-top: 3px;
      font-size: 9px;
      font-weight: 500;
      line-height: 1;
      color: #555;
    }

    .deliving-pdp-colour-helper {
      margin: 7px 0 0;
      color: #777;
      font-size: 12px;
      line-height: 1.3;
    }

    @media screen and (max-width: 749px) {
      .deliving-card-colours {
        margin-top: 7px;
        margin-bottom: 5px;
      }

      .deliving-card-colours__row {
        gap: 5px;
      }

      .deliving-card-colour-swatch,
      .deliving-card-colour-more {
        width: 36px;
        min-width: 36px;
        height: 36px;
        min-height: 36px;
        border-radius: 0;
      }

      .deliving-card-colour-swatch {
        border-radius: 0;
      }

      .deliving-card-colour-more {
        font-size: 13px;
      }

      .deliving-card-colours__summary {
        margin-top: 6px;
        font-size: 11px;
      }
    }
  `;
  document.head.appendChild(style);
}

function stopCardEvent(event) {
  event.stopPropagation();
}

function upgradeCardColours(root = document) {
  root.querySelectorAll('[data-deliving-card-colours]').forEach((container) => {
    if (container.dataset.delivingColourReady === 'true') return;
    container.dataset.delivingColourReady = 'true';

    const extras = Array.from(container.querySelectorAll('.deliving-card-colour-extra'));
    const toggle = container.querySelector('[data-deliving-card-colour-toggle]');
    const summary = container.querySelector('.deliving-card-colours__summary');
    const summaryTextNode = summary
      ? Array.from(summary.childNodes).find(
          (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
        )
      : null;
    const collapsedSummary = summaryTextNode?.textContent.trim() || '';

    container.querySelectorAll('a, button').forEach((control) => {
      control.addEventListener('pointerdown', stopCardEvent);
      control.addEventListener('click', stopCardEvent);
    });

    if (!toggle || !extras.length) return;

    const count = Number.parseInt(toggle.dataset.count || `${extras.length}`, 10) || extras.length;

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const expanded = container.dataset.expanded !== 'true';
      container.dataset.expanded = expanded ? 'true' : 'false';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.setAttribute(
        'aria-label',
        expanded ? 'Show fewer colours' : `Show ${count} more colours`
      );

      extras.forEach((item) => {
        item.hidden = !expanded;
      });

      if (summaryTextNode) {
        summaryTextNode.textContent = expanded
          ? ' All colours shown'
          : ` ${collapsedSummary}`;
      }
    });
  });
}

function getPdpSwatchItems(list) {
  return Array.from(list.children).filter((element) => {
    if (!(element instanceof HTMLElement)) return false;
    return element.tagName === 'LI' && Array.from(element.classList).some((name) => name.startsWith('ai-color-swatches-item-'));
  });
}

function syncPdpMoreSize(list, items) {
  const sample = items[0]?.querySelector('[class*="ai-color-swatches-swatch-"]') || items[0]?.firstElementChild;
  if (!(sample instanceof HTMLElement)) return;

  const rect = sample.getBoundingClientRect();
  if (rect.width > 0) list.style.setProperty('--deliving-pdp-colour-width', `${Math.round(rect.width)}px`);
  if (rect.height > 0) list.style.setProperty('--deliving-pdp-colour-height', `${Math.round(rect.height)}px`);
}

function upgradePdpColours(root = document) {
  root.querySelectorAll('ul[class*="ai-color-swatches-list-"]').forEach((list) => {
    if (!(list instanceof HTMLElement) || list.dataset.delivingColourReady === 'true') return;

    const items = getPdpSwatchItems(list);
    if (items.length <= 5) {
      list.dataset.delivingColourReady = 'true';
      return;
    }

    list.dataset.delivingColourReady = 'true';
    const extras = items.slice(5);
    extras.forEach((item) => {
      item.classList.add('deliving-pdp-colour-extra');
      item.hidden = true;
    });

    syncPdpMoreSize(list, items);

    const hiddenCount = extras.length;
    const moreItem = document.createElement('li');
    moreItem.className = 'deliving-pdp-colour-more-item';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'deliving-pdp-colour-more-button';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', `Show ${hiddenCount} more colours`);

    const setButtonContent = (expanded) => {
      button.innerHTML = expanded
        ? '<span class="deliving-pdp-colour-more-count">−</span><span class="deliving-pdp-colour-more-label">less</span>'
        : `<span class="deliving-pdp-colour-more-count">+${hiddenCount}</span><span class="deliving-pdp-colour-more-label">more</span>`;
    };

    setButtonContent(false);
    moreItem.appendChild(button);
    list.appendChild(moreItem);

    const helper = document.createElement('p');
    helper.className = 'deliving-pdp-colour-helper';
    helper.textContent = `Tap +${hiddenCount} more to see all colours`;
    list.insertAdjacentElement('afterend', helper);

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        expanded ? 'Show fewer colours' : `Show ${hiddenCount} more colours`
      );

      extras.forEach((item) => {
        item.hidden = !expanded;
      });

      setButtonContent(expanded);
      helper.textContent = expanded
        ? 'All colours shown'
        : `Tap +${hiddenCount} more to see all colours`;
    });
  });
}

function upgrade(root = document) {
  injectStyles();
  upgradeCardColours(root);
  upgradePdpColours(root);
}

upgrade(document);

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      upgrade(node);
    }
  }
});

if (document.body) {
  observer.observe(document.body, { childList: true, subtree: true });
}

window.addEventListener('resize', () => {
  document.querySelectorAll('ul[class*="ai-color-swatches-list-"][data-deliving-colour-ready="true"]').forEach((list) => {
    if (!(list instanceof HTMLElement)) return;
    const items = getPdpSwatchItems(list);
    syncPdpMoreSize(list, items);
  });
}, { passive: true });
